var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryCarOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49463 16.3325C7.59893 16.3325 8.49414 15.3224 8.49414 14.0763C8.49414 12.8302 7.59893 11.8201 6.49463 11.8201C5.39033 11.8201 4.49512 12.8302 4.49512 14.0763C4.49512 15.3224 5.39033 16.3325 6.49463 16.3325Z",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 16.3325C17.6038 16.3325 18.499 15.3224 18.499 14.0763C18.499 12.8302 17.6038 11.8201 16.4995 11.8201C15.3952 11.8201 14.5 12.8302 14.5 14.0763C14.5 15.3224 15.3952 16.3325 16.4995 16.3325Z",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54343 14.0768H13.4922V2.34435C13.4922 1.97053 13.2237 1.66748 12.8924 1.66748H1.68262",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14935 14.075H2.09985C1.76856 14.075 1.5 13.772 1.5 13.3981V7.87036",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68262 4.48608H5.68164",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.502 5.0481H19.1107C19.3477 5.0481 19.5626 5.20563 19.6588 5.45007L21.4483 9.99331C21.4824 10.08 21.5 10.1736 21.5 10.2682V13.3962C21.5 13.77 21.2315 14.073 20.9001 14.073H19.0006",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.502 14.0784H14.5017",
    stroke: "#2A2D2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryCarOff);
export default __webpack_public_path__ + "static/media/deliveryCarOff.b437ddbab8c8caeb6357093c400ac10d.svg";
export { ForwardRef as ReactComponent };